import React from 'react';
import Academy from '../Components/Academy';
import Coach from '../Components/Coach';
import Footer from '../Components/Footer';
import JoinForm from '../Components/JoinForm';
import Latest from '../Components/Latest';
import Navbar from '../Components/Navbar';
import Social from '../Components/Social';
import Youtube from '../Components/Youtube';
import coach1 from '../img/coach/life.png'
import coach2 from '../img/coach/relationship.png'
import coach3 from '../img/coach/grief-supp.png'
import coach4 from '../img/coach/self-dev.png'
import coach5 from '../img/coach/goal settin.png'

const Home = () => {
    const coach = [
        {
            img: coach1,
            info: "Life Coaching",
            des: "We counsels and encourages you through personal or career challenges. We help guide our clients to reach their ultimate goals, and  help individuals in different areas of their life. We understand each human being is different so we work closely to fingre out the issue. Book a free consultation now with Rabinandan."
        },
        {
            img: coach2,
            info: "Relationship Coaching",
            des: "Are you going through with a tough moment in  your relationship? Does your partner not care you or do not meet your expections? Does your married life lost love? Do not worry any more. We are here to help you. Book a free consultation with me and get a new spark in your romantic relationship. "
        },
        {
            img: coach3,
            info: "Grief Support",
            des: "We, as  human, do not have control over others' actions. It is likely to get hurted by someone's action. If you are also feeling thretended, depressed and alone then you are not alone and it is not something that happend for the first time. Many people also experienced same. Let me know your sadness and give me this opportunaity to lift you up. Book a free consultation now. "
        },
        {
            img: coach4,
            info: "Self Development",
            des: "We all talk about seft development, some of us even make plans, goals and stick with it for a certain duration. Moreover, with the time or by other factors more than 99% of us stop working on our plans. And, the rest 1% will active the magiz so called 'success'. Let's work on your self development together."
        },
        {
            img: coach5,
            info: "Goal settings",
            des: "Try to remember how many times you have set goals for yourself? I am sure it would be not less that 10 times. No doubt, you have started everytime but it is also true, after a few days or months the inspiration has gone. One of the reason is the the goal you set was not ACTUALLY yours. Lets work together to identify - where you are best at & how can you achive it ?  "
        },
        {
            img: coach5,
            info: "Goal settings",
            des: "Try to remember how many times you have set goals for yourself? I am sure it would be not less that 10 times. No doubt, you have started everytime but it is also true, after a few days or months the inspiration has gone. One of the reason is the the goal you set was not ACTUALLY yours. Lets work together to identify - where you are best at & how can you achive it ?  "
        }
    ]
    const research = [
        {
            img: "https://thumbs.dreamstime.com/b/woman-writing-blog-content-notebook-table-closeup-162627112.jpg",
            info: "Artificial Intelligence",
            para: "coming soon"
        },
        {
            img: "https://thumbs.dreamstime.com/b/woman-writing-blog-content-notebook-table-closeup-162627112.jpg",
            info: "Project Management",
            para: 'coming soon'
        }
    ]
    const learning = [
        {
            name: "JLPT study",
            para: "The Japanese-Language Proficiency Test (日本語能力試験, Nihongo Nōryoku Shiken), or JLPT, is a standardized criterion-referenced test to evaluate and certify Japanese language proficiency for non-native speakers, covering language knowledge, reading ability, and listening ability.The test is held twice a year in Japan and selected countries (on the first Sunday of July and December), and once a year in other regions (on the first Sunday of December).The JLPT consists of five levels. To join JLPT classes, enroll now for FREE. "
        },
        {
            name: "Business Japanese",
            para: "It is very important to understand business Japanese before you plan to move or work in Japan. Japan is a very polite and sensitive country and in different settings, like business, casual, they speak differently. We teach you business Japanese and business adequately and help you to get a good score in BJT."
        },
        {
            name: "Japanese Culture Center",
            para: "Japan is a bucket lister’s paradise. It’s a place where traditional and modern culture mix to create something incomparable. There are experiences here unlike anywhere else, but if you come unprepared, you might miss out. We help you understand Japanese culture and let you explore the country with ease. "
        },
        {
            name: "Jobs in Japan",
            para: "We provide different types of Job services in japan. Whether you are an IT engineer, constructor worker, manager or TITP intern, we have support for you to start your new working life in Japan. Enroll now and get started."
        },
        {
            name: "Immigrate to Japan",
            para: "Immigration to Japan is not an easy process but we support you at every step of your application. One of the easiest ways to immigrate is to start working in Japan on a long term VISA. We also provide support for Japanese PR. Send us your inquiry now. "
        },
        {
            name: "Study in Japan",
            para: "We collaborate with the best Japanese language schools across Japan. Our coordinators will help you pick a program that fits your learning preferences and future study goals. We also support you to get admission in other courses for master, phd and bachelors."
        }
    ]
    const latestNews = [
        {
            title: "Birthday Celebration",
            date: "13 Dec 2022",
            paragraph: " Thank you everybody, especially Cho san from Korea, to make my day spacial. Although I turned 29 this year, I feel younger and energatic when I am with you people.",
        },
        {
            title: "Completion of DL Research  ",
            date: "10 Dec 2022",
            paragraph: " I am happy to announced the status of current research.",
        },
        {
            title: "Completion of Meta Research",
            date: "4 Dec 2022",
            paragraph: "I am happy to announce that I have completed the meta research for Visual Question Answering (VQA) Systems.",
        },
        {
            title: "Certification from The Academy of Modern Applied Psychology",
            date: "20 Nov 2022",
            paragraph: "It is my houner to receive a certificate from Kain Ramsay for the 'Lafe Coaching course'.",
        },
        {
            title: "Research proposal has been finalized",
            date: "03 Oct 2022",
            paragraph: "The research proosal has been finalized on the topic 'Embodying a SMARTMedical Assistant' for 2023 research. Look for research section for detailed information. ",
        },
        {
            title: "Business Japanese",
            date: "24 August 2022",
            paragraph: "Rabinandan Kishor has taken BJT certification course and obtained a score of 398.",
        },
        {
            title: "Certification from Transformation Services",
            date: "03 May 2022",
            paragraph: "I'm happy to announce I have earned a certificate of 'Relationship coaching'. The course was conducted by Joeel & Natalia.",
        }
    ]
    return (
        <div>
            <div className=' xl:px-20 lg:py-10 p-5'>
                <Youtube latestNews={latestNews}></Youtube>
                <Academy title="Maya Japanese Center" id=''></Academy>
                <Coach data={learning} learning></Coach>
                <Coach data={coach} coach title="Coach Yourself"></Coach>
                <JoinForm title="Book Free Consultation" free />
                <Coach data={research} research title="Research Overview"></Coach>
                <Latest btn='All news' latestNews={latestNews} all></Latest>
                {/* <Social></Social> */}
            </div>

        </div>
    );
};

export default Home;
